import * as React from 'react';

import { useSelector } from 'react-redux';
import { freezeBody, unfreezeBody } from '../modal/modal-utils';

import closeX from '../../assets/closeX.png';
import CartIcon from './CartIcon';
import Cart from './Cart';
import PropTypes from 'prop-types';

import styles from './SlideInCart.module.css'; 

const SlideInCart  = ({
  isWideScreen, 
  forceClose}) => {

  const items = useSelector(state => state.addedItems);
  const [isOpen, setOpen] = React.useState();
  const cartInLayoutPages = ['dispensary', 'placeOrder']; 
  
  const handleIconClick = () => {
    const pathItems = window.location.pathname.split('/');
    const cartInLayout = pathItems.length > 0 && cartInLayoutPages.indexOf(pathItems[1]) > -1;
    if (!(isWideScreen && cartInLayout)) {  
      toggleOpen();
    }
  }
  
  const toggleOpen = () => {
    // Only freeze body on mobile 
    if (window.innerWidth <= 480) {
      if (isOpen) {
        unfreezeBody();
      } else {
        freezeBody();
      }
    }

    // Make sure that a header/footer slide-in cart is not already open.
    if (!isOpen) {
      const winWidth = window.innerWidth;
      const carts = document.querySelectorAll('#MENU_CART')
      const [alreadyOpen] = [ ...carts].filter(cart => {
        return cart && cart.getBoundingClientRect().x <= winWidth; 
      });  
      if (alreadyOpen) {
        return;
      }
    }
    setOpen(!isOpen); 
  };

  let openStyle = isOpen ? styles.open : ''; 
  
  // If we are forcing cart closed via prop (FooterNav)
  if (forceClose) {
    if (isOpen) {
      setOpen(false);
    }
    openStyle = '';
    unfreezeBody();
  }
  
  return (
    <>
      <span onClick={handleIconClick}>
        <CartIcon items={items} />
      </span>
      <div className={`${styles.slideInCart} ${openStyle}`}> 
        <div className={styles.cropShadow}>
          <button className={styles.closeIcon} onClick={toggleOpen} type="button" size="16" kind="BUTTON/PLAIN" aria-label="Close">
            <img alt="" className={styles.closeX} src={closeX} /> 
          </button>
          <Cart 
            isInMenu={true} 
            closeMenuFn={toggleOpen} />
        </div>
      </div>
    </>
  );
}

SlideInCart.propTypes = {
  isWideScreen: PropTypes.bool,
  forceClose: PropTypes.bool
};

export default SlideInCart;
